import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";

const languages = [
  { code: "en", name: "English", flag: "GB" },
  { code: "tr", name: "Türkçe", flag: "TR" },
/*   { code: "fr", name: "French", flag: "FR" },
  { code: "de", name: "Deutch", flag: "DE" },
  { code: "es", name: "Spanish", flag: "ES" }, */
  { code: "cn", name: "Chinese", flag: "CN" },
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const currentLang =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    handleClose();
  };

  return (
    <>
      <IconButton
        sx={{
          marginLeft: "auto",
          marginRight: ".5rem",
          width: 48,
          height: 48,
          padding: ".5rem",
        }}
        onClick={handleClick}
        size="large"
        aria-label="Languages button"
      >
        <img
          loading="lazy"
          alt={currentLang.flag}
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${currentLang.flag}.svg`}
          style={{
            width: "100%",
            objectFit: "contain",
            borderRadius: 8,
          }}
        />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 8,
          sx: {
            minWidth: 160,
            p: 1,
            boxSizing: "content-box",
            "& .MuiList-root": {
              p: 0, // padding: 0
            },
          },
        }}
      >
        <SimpleBar
          style={{
            maxHeight: "120px",
            
          }}
        >
          {languages.map((lang) => (
            <MenuItem
              sx={{
                borderRadius: ".75rem",
                marginBottom: ".25rem",
              }}
              key={lang.code}
              selected={i18n.language === lang.code}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <ListItemIcon>
                <img
                  loading="lazy"
                  alt={lang.flag}
                  src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${lang.flag}.svg`}
                  style={{ width: 24, height: 18, borderRadius: 3 }}
                />
              </ListItemIcon>
              <ListItemText>{lang.name}</ListItemText>
            </MenuItem>
          ))}
        </SimpleBar>
      </Menu>
    </>
  );
}
